import React from "react";
import * as Icon from "react-bootstrap-icons";
import styles from "./GridSearchInput.module.css";

interface GridSearchInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  disabled?: boolean;
  loading?: boolean;
  width?: number | string;
  height?: number;
}

export const GridSearchInput: React.FC<GridSearchInputProps> = ({
  value,
  placeholder,
  onChange,
  onSearch,
  onKeyDown,
  disabled = false,
  loading = false,
  width = 320,
  height = 36,
}) => (
  <div className={styles.searchWrapper} style={{ width }}>
    <input
      type="text"
      className={`form-control ${styles.searchInput}`}
      style={{ height }}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={onKeyDown}
    />
    <button
      type="button"
      className={styles.searchIconButton}
      onClick={onSearch}
      aria-label="Search"
      disabled={disabled}
    >
      {loading ? (
        <Icon.ArrowRepeat className={styles.searchingSpinner} />
      ) : (
        <Icon.Search />
      )}
    </button>
  </div>
);
